import GridContainer from "../../layout/page/container/GridContainer";
import CustomImage from "../image";
import ScdSendMail from "../../../resources/images/scd-send-mail.svg";
import CustomTypography from "../typography";
import { useMessageSource } from "react-message-source";

import "./styles.scss";
import TypographyItemContainer from "../../layout/page/typography-container/typography-item-container";

function PostalAddress() {
  const { getMessage } = useMessageSource();

  return (
    <>
      <TypographyItemContainer>
        <CustomTypography variant="h4">
          {getMessage("CardholderConfirmation-at")}
        </CustomTypography>
      </TypographyItemContainer>

      <GridContainer className="post-address-container">
        <div className="post-address-image">
          <CustomImage src={ScdSendMail} />
        </div>
        <div className="post-address-location">
          <CustomTypography>
            {getMessage("PostalAddress.location")}
          </CustomTypography>
          <CustomTypography>
            {getMessage("PostalAddress.location-third")}
          </CustomTypography>
          <CustomTypography>
            {getMessage("PostalAddress.location-forth")}
          </CustomTypography>
        </div>
      </GridContainer>
    </>
  );
}

export default PostalAddress;
